import React, { useState, useEffect, useRef } from "react";

// ── Palette & helpers ──────────────────────────────────────────────────────
const C = {
  bg: "#f1f5f9", card: "#ffffff", border: "#e2e8f0",
  accent: "#2563eb", accent2: "#10b981", accent3: "#f59e0b",
  danger: "#ef4444", text: "#0f172a", muted: "#64748b",
  purple: "#0095FF", pink: "#0F2942"
};


// ── Export utilities ────────────────────────────────────────────────────────

export default C;
